import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LoadingState {
  global: boolean;
}

const initialState: LoadingState = {
  global: false,
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setGlobalLoading: (state: LoadingState, action: PayloadAction<boolean>) => {
      state.global = action.payload;
    },
  },
});

export const { setGlobalLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
